export default "__VITE_ASSET__fb80789a__"